/**
 * RR
 * Club Manage is part of assets/ClubManager folder
 * Same stucutre is followed on React-Native-Wexer-App
 */
// Nikhil --> Uncomment the code for SSO
export * from "../assets/ClubManager/action";  
// module.exports = require('../assets/ClubManager/action');  